import * as React from 'react';
import * as classNames from 'classnames';
import {SFC} from 'react';
import './styles.sass';

interface IAccordionItemProps {
  children: any;
  expanded: boolean;
}

export const AccordionItem: SFC<IAccordionItemProps> = ({children, expanded}) => (
  <div className={classNames('accordion-item', {'accordion-item_expanded': expanded})}>
    {children}
  </div>
);
